import { BridgeLocale } from '~/types'

export const KYC_TYPE_OPTIONS = [
  {
    value: 'individual' as const,
    label: 'Individual (KYC)',
    description: 'Have ready ID, address, tax number, and DOB',
  },
  {
    value: 'business' as const,
    label: 'Business (KYB)',
    description: 'Have ready formation docs, EIN, and KYC on all major owners',
  },
]

export const SOURCE_CURRENCY_BY_LOCALE: Record<string, string> = {
  us: 'usd',
  eu: 'eur',
} satisfies Record<BridgeLocale, string>

export const DESTINATION_CURRENCY_BY_SOURCE_LOCALE: Record<string, string> = {
  us: 'usdc',
  eu: 'eurc',
} satisfies Record<BridgeLocale, string>

export const LOCALE_BY_SOURCE_CURRENCY: Record<string, BridgeLocale> = {
  usd: 'us',
  eur: 'eu',
} satisfies Record<string, BridgeLocale>

export const AVAILABLE_LOCALES = [
  'us',
  'eu',
] as const satisfies Array<BridgeLocale>

export type AvailableLocale = (typeof AVAILABLE_LOCALES)[number]

export const DEFAULT_CUSTOMER_LOCALES: Array<AvailableLocale> = ['us']

export const VIRTUAL_ACCOUNT_LABEL: Record<string, string> = {
  us: 'US',
  eu: 'EU/IBAN',
} satisfies Record<(typeof AVAILABLE_LOCALES)[number], string>

export const LOCALE_CHECKBOX_OPTIONS = [
  {
    value: 'us' as const,
    label: 'US account',
    description: 'Used for ACH/wires',
  },
  {
    value: 'eu' as const,
    label: 'EU account',
    description: 'Used for IBAN/SEPA',
  },
]
